export const isLastDayOfTheMonth = (day: number, month: number, year: number) => {
  const date = new Date(year, month + 1, 0);
  return date.getUTCDate() === new Date(year, month, day).getUTCDate();
};
